import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';
import { RxHeart, RxHeartFilled } from "react-icons/rx";
import { FaRegCommentDots } from "react-icons/fa6";
import { STR_BUY_NOW, STR_CANCEL_ORDER, STR_CART_WAS_UPDATED, STR_CLICK_TO_VIEW_COMMENTS, STR_CONTACT_US, STR_IS_CANCELLED, STR_IS_DELIVERED, STR_IS_PAID, STR_IS_SHIPPED, STR_MAKE_PAYMENT, STR_NO, STR_ORDERED_ITEMS, STR_OVERALL_COST, STR_SHIPPING_COST, STR_SUCCESS, STR_TRANSACTION_FEES, STR_WRITE_YOUR_COMMENT, STR_YES } from "../Strings";
import LoginView from '../views/LoginView';
import ImagesSlider from "../ones/ImagesSlider";
import { MdAdd, MdLocationPin } from "react-icons/md";
import { BiMinus, BiSolidCartDownload } from "react-icons/bi";


export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [data, setData] = useState(null);
	const [shippingAddress, setShippingAddress] = useState(null);
	const [loading, setLoading] = useState(false);


	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}

	async function cancelOrder() {
		setLoading(true);
		await callApi("cancel-pharmacy-order", { orderId: id }).then(response => {
			if (response.status === 1) {
				getData();
				appContext.tellMessage(STR_SUCCESS[appContext.language]);
			} else {
				appContext.tellError(response.msg)
			}
		})
		setLoading(false);
	}

	async function getData() {
		await callApi("get-pharmacy-order-data", { id }).then(response => {
			if (response.status === 1) {
				setData(response.data);
			}
		})
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])


	useEffect(() => {
		if(data) {
			setShippingAddress(JSON.parse(data.shippingAddress));
		}
	}, [ data ])
	
	if (ready && data) {
		return (
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<div
							className="mt-4 mb-4"
						>
							<h6
								style={{
									fontSize: "22px"
								}}
								className="font-bold text-secondary"
							>
								TZS {formatMoney(data.overallCost)}
							</h6>
				
							<h6
								style={{
									fontSize: "12px"
								}}
								className="font-bold text-muted mt-2 mb-2"
							>
								ID: <span className="text-secondary font-bold">{data.uid}</span>
							</h6>
				
							<h6
								style={{
									fontSize: "12px"
								}}
								className="font-regular mt-4 text-end"
							>
								{formatDate(data.dateCreated)}
							</h6>
				
				
						</div>
						
						<div className="card">
							<div className="card-body">
								<h6 className="card-title">
									{STR_ORDERED_ITEMS[appContext.language]}
								</h6>
								<hr/>
								{
									(JSON.parse(data.items)).map((item, i) => {
										return (
											<div
												key={i}
												style={{
													width: "100%"
												}}
											>
												<h6
												 className="font-semi-bold"
												 style={{
													fontSize: "14px"
												 }}
												>
													{item.title}
												</h6>

												<h6
												 className="font-regular text-end"
												 style={{
													fontSize: "16px"
												 }}
												>
													x{item.itemQuantity} {item.unit}
												</h6>

												<h6
												 className="font-regular text-end"
												 style={{
													fontSize: "18px"
												 }}
												>
													TZS {formatMoney(item.unitPrice * item.itemQuantity)}
												</h6>

												<hr/>
											</div>
										)
									})
								}

								<div 
									className="mt-4 mb-2 bg-background"
									style={{ 
										padding: "10px",
										borderBottom: "2px solid var(--onBackgroundColor)"
									}}
								>
									<h6
										className="font-semi-bold"
										style={{
										fontSize: "14px"
										}}
									>
										{STR_SHIPPING_COST[appContext.language]}
									</h6>

									<h6
										className="font-semi-bold text-end"
										style={{
										fontSize: "14px"
										}}
									>
										TZS {formatMoney(data.shippingCost)}
									</h6>

									<hr/>

									<h6
										className="font-semi-bold"
										style={{
										fontSize: "14px"
										}}
									>
										{STR_TRANSACTION_FEES[appContext.language]}
									</h6>

									<h6
										className="font-semi-bold text-end"
										style={{
										fontSize: "14px"
										}}
									>
										TZS {formatMoney(data.transactionFees)}
									</h6>

									<hr/>

									<h6
										className="font-semi-bold"
										style={{
										fontSize: "14px"
										}}
									>
										{STR_OVERALL_COST[appContext.language]}
									</h6>

									<h6
										className="font-bold text-end"
										style={{
										fontSize: "24px"
										}}
									>
										TZS {formatMoney(data.overallCost)}
									</h6>
								</div>

								
							</div>
						</div>
					</div>

					{
						(shippingAddress) ?
						<div className="col-12 mt-4 mb-4">
							<MdLocationPin size={32}/>
							<h6
								style={{
									fontSize: "18px"
								}}
								className="font-semi-bold"
							>
								{(shippingAddress.region) ? <>{shippingAddress.region},</> : ""}
								{(shippingAddress.district) ? <>{shippingAddress.district},</> : ""}
								{(shippingAddress.ward) ? <>{shippingAddress.ward},</> : ""}
								{(shippingAddress.street) ? <>{shippingAddress.street},</> : ""}
							</h6>
						</div>
						:""
					}

					<div className="col-6 col-md-4 mt-4 mb-4">
						<label className="form-label">{STR_IS_PAID[appContext.language]}</label>
						<h6
							style={{
								fontSize: "18px"
							}}
							className="font-semi-bold"
						>
							{
								(data.isPaid === 'yes') ?
								<span className="font-semi-bold text-secondary">{STR_YES[appContext.language]}</span>
								:
								<span className="font-semi-bold text-danger">{STR_NO[appContext.language]}</span>
							}
						</h6>
					</div>

					
					<div className="col-6 col-md-4 mt-4 mb-4">
						<label className="form-label">{STR_IS_CANCELLED[appContext.language]}</label>
						<h6
							style={{
								fontSize: "18px"
							}}
							className="font-semi-bold"
						>
							{
								(data.isCancelled === 'yes') ?
								<span className="font-semi-bold text-secondary">{STR_YES[appContext.language]}</span>
								:
								<span className="font-semi-bold text-danger">{STR_NO[appContext.language]}</span>
							}
						</h6>
					</div>

					<div className="col-6 col-md-4 mt-4 mb-4">
						<label className="form-label">{STR_IS_SHIPPED[appContext.language]}</label>
						<h6
							style={{
								fontSize: "18px"
							}}
							className="font-semi-bold"
						>
							{
								(data.isShipped === 'yes') ?
								<span className="font-semi-bold text-secondary">{STR_YES[appContext.language]}</span>
								:
								<span className="font-semi-bold text-danger">{STR_NO[appContext.language]}</span>
							}
						</h6>
					</div>

					<div className="col-6 col-md-4 mt-4 mb-4">
						<label className="form-label">{STR_IS_DELIVERED[appContext.language]}</label>
						<h6
							style={{
								fontSize: "18px"
							}}
							className="font-semi-bold"
						>
							{
								(data.isDelivered === 'yes') ?
								<span className="font-semi-bold text-secondary">{STR_YES[appContext.language]}</span>
								:
								<span className="font-semi-bold text-danger">{STR_NO[appContext.language]}</span>
							}
						</h6>
					</div>

					<div className="col-md-12 mb-5 mt-2">

						<div className="row">
							{
								(
									data.isCancelled === 'no' &&
									data.isPaid === 'no'
								) ?
								<div className="col-12">
									<button
										className="btn btn-block btn-secondary btn-padded mt-2 mb-2"
										onClick={() => {
											appContext.navTo({
												item: 'view',
												subItem: 'pharmacy-order-payment',
												extraItem: data.id,
											})
										}}
									>
										{STR_MAKE_PAYMENT[appContext.language]}
									</button>
								</div>
								:""
							}

							<div className="col-6">
								<button
									className="btn btn-block btn-dark btn-padded btn-sm mt-2 mb-2"
									onClick={() => {
										appContext.navTo({
											item: 'view',
											subItem: 'contact-us'
										})
									}}
								>
									{STR_CONTACT_US[appContext.language]}
								</button>
							</div>

							{
								(
									data.isCancelled === 'no' &&
									data.isPaid === 'no' &&
									data.isDelivered === 'no' &&
									data.isShipped === 'no'
								) ?
								<div className="col-6">
									<button
										className="btn btn-block btn-danger btn-sm btn-padded mt-2 mb-2"
										onClick={() => {
											appContext.activateDialog({
												message: STR_CANCEL_ORDER[appContext.language],
												onConfirm: cancelOrder,
											})
										}}
									>
										{STR_CANCEL_ORDER[appContext.language]}
									</button>
								</div>
								:""
							}

						</div>
					</div>

				</div>
			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading container"
			>
				{getInlineLoader()}
			</div>
		);
	}
	

}